import React, { useEffect, useState } from 'react';
import "./FlightDetails.css"
import dateFormat from 'dateformat';
import { getFormatedDate } from '../../ReusableComponents/reusableFunctions';
import Button from '../../ReusableComponents/Button/Button';
import { AnimatedModal } from '../../ReusableComponents/AnimatedModal';
import closeIcon from "../../icons/blackClose.png"
import logAnalyzerIcon from '../../icons/logAnalyzerIcon.svg'
import reportIcon from '../../icons/reportIcon.svg'
import replayIcon from '../../icons/replayIcon.svg'
import detailsIcon from '../../icons/DetailsIcon.svg'
import { Link } from "react-router-dom";
import ButtonWithIcon from '../../ReusableComponents/ButtonWithIcon';

const FlightDetailsBanner = ({ user, type, planName, projectName, requestId, date, flightID, startTime, endTime, avgAltitude, avgSpeed, onReplayFlight, onViewDetaiils, areaCovered, areaCoveredMethod, distanceCovered, droneId, firmwareVersion, greenBuildNumber, droneName, droneUIN, software_edition, plotArea, reportData, consumedLiquid, acresByPilot, sprayWidth, pilotName, acres, cost, totalCost, isDroneInMaintenanceMode, gpsInfo }) => {
    const [showReport, setShowReport] = useState(false);
    console.log("flightID", flightID, "reportData", reportData)
    return <>
        {reportData && <AnimatedModal
            isOpen={showReport}
            height={"410px"}
            width={"45%"}
        >
            <div style={{ width: '100%', height: '100%', textAlign: 'left', padding: '10px 30px' }}>
                <div className="droneDetailsViewTitle">Report Details{requestId && <span style={{ fontWeight: '500' }}>  | Req ID: {requestId}</span>}</div>
                <hr style={{ margin: '10px 0px 0px 0px', width: '100%' }} />
                <div className="droneDetailsViewInfo" style={{ width: '100%' }}>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Customer Name">Customer Name</div>
                        <div className="droneDetailsViewValues" title={reportData?.customer_name ? reportData?.customer_name : "NA"}>{reportData?.customer_name ? reportData?.customer_name : "NA"}</div>
                    </div>
                    <div style={{ width: '39%' }}>
                        <div className="droneDetailsViewHeadings" title="Crop Type">Crop Type</div>
                        <div className="droneDetailsViewValues" title={reportData?.crop_type ? reportData?.crop_type : "NA"}>{reportData?.crop_type ? reportData?.crop_type : "NA"}</div>
                    </div>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Agrochemical">Agrochemical</div>
                        <div className="droneDetailsViewValues" title={reportData?.pesticide ? reportData?.pesticide : "NA"}>{reportData?.pesticide ? reportData?.pesticide : "NA"}</div>
                    </div>
                </div>
                <div className="droneDetailsViewInfo" style={{ width: '100%' }}>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Total Amount">Total Amount</div>
                        <div className="droneDetailsViewValues" title={reportData?.amount ? `${reportData?.amount} Rs.` : "NA"}>{reportData?.amount ? `${reportData?.amount} Rs.` : "NA"}</div>
                    </div>
                    <div style={{ width: '39%' }}>
                        <div className="droneDetailsViewHeadings" title="Drone Id">Drone Id</div>
                        <div className="droneDetailsViewValues" title={droneId ? droneId : "NA"}>{droneId ? droneId : "NA"}</div>
                    </div>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Spray Volume">Spray Volume</div>
                        <div className="droneDetailsViewValues" title={reportData?.spray_volume ? reportData?.spray_volume : "NA"}>{reportData?.spray_volume ? reportData?.spray_volume : "NA"}</div>
                    </div>
                </div>
                <div className="droneDetailsViewInfo" style={{ width: '100%' }}>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Completed">Completed</div>
                        <div className="droneDetailsViewValues" title={reportData?.area_percentage ? `${reportData?.area_percentage} %` : "NA"}>{reportData?.area_percentage ? `${reportData?.area_percentage} %` : "NA"}</div>
                    </div>
                    <div style={{ width: '39%' }}>
                        <div className="droneDetailsViewHeadings" title="Sprayed Area">Sprayed Area</div>
                        <div className="droneDetailsViewValues" title={reportData?.spray_area ? `${reportData?.spray_area} Acr` : "NA"}>{reportData?.spray_area ? `${reportData?.spray_area} Acr` : "NA"}</div>
                    </div>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Plot Area">Plot Area</div>
                        <div className="droneDetailsViewValues" title={reportData?.plot_area ? `${reportData?.plot_area} Acr` : "NA"}>{reportData?.plot_area ? `${reportData?.plot_area} Acr` : "NA"}</div>
                    </div>
                </div>
                <div className="droneDetailsViewInfo" style={{ width: '100%' }}>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Spray Width">Spray Width</div>
                        <div className="droneDetailsViewValues" title={sprayWidth ? `${sprayWidth} m` : "NA"}>{sprayWidth ? `${sprayWidth} m` : "NA"}</div>
                    </div>
                    <div style={{ width: '39%' }}>
                        <div className="droneDetailsViewHeadings" title="Date">Date</div>
                        <div className="droneDetailsViewValues" title={reportData?.created_datetime ? dateFormat(reportData?.created_datetime, 'dd/mm/yyyy') : "NA"}>{reportData?.created_datetime ? dateFormat(reportData?.created_datetime, 'dd/mm/yyyy') : "NA"}</div>
                    </div>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Flight Time">Flight Time</div>
                        <div className="droneDetailsViewValues" title={reportData?.flight_time ? reportData?.flight_time : "NA"}>{reportData?.flight_time ? reportData?.flight_time : "NA"}</div>
                    </div>
                </div>

                <div style={{ display: 'flex', width: '100%', alignItems: 'flex-end', justifyContent: 'flex-end', marginTop: '20px' }}>
                    <Button
                        className={'new-btn-md'}
                        isBtnActive={true}
                        text={"Ok"}
                        onClick={() => { setShowReport(false) }}
                    />
                </div>
            </div>
        </AnimatedModal>}

        <div className='flight_details_banner_container'>
            <div className='flight_details_banner_header' >
                <div className='flight_details_banner_header_right'>
                    <div className='grid_container' style={{ width: "70%" }}>
                        <div className='grid_data' style={{ color: 'white', fontSize: "20px" }}> {`${projectName} / ${planName}`}</div>
                        <div className='grid_title' style={{ color: 'white' }}>  {flightID}</div>
                    </div>

                    {requestId &&
                        <div className='grid_container' style={{ width: "30%" }}>
                            <div className='grid_data' style={{ color: 'white', fontSize: "20px" }}>Request ID</div>
                            <div className='grid_title' style={{ color: 'white' }}>{requestId || ''}</div>
                        </div>
                    }

                </div>
                <div className='flight_details_banner_header_left'>
                    {isDroneInMaintenanceMode && <div style={{ fontSize: "14px", backgroundColor: '#DE9000', padding: '8px 10px', borderRadius: "8px" }}>In Maintenance</div>}
                    {flightID && reportData && <div className='flightDetailsConainerIcon'>
                        <img src={reportIcon} title='Report' className='flightDetailsIcon' onClick={() => { setShowReport(true) }} />
                    </div>}
                    <div className='flightDetailsConainerIcon'>
                        <Link
                            to={{
                                pathname: '/aerogcsenterprise/flight_logAnalyzer',
                                state: {
                                    user,
                                    flightId: flightID,
                                    request_id: requestId,
                                    planName: planName,
                                    projectName: projectName,
                                    date: date,
                                    startTime: startTime,
                                    endTime: endTime,
                                    avgAltitude: avgAltitude,
                                    avgSpeed: avgSpeed,
                                    onViewDetaiils: onViewDetaiils,
                                    areaCovered: areaCovered,
                                    areaCoveredMethod: areaCoveredMethod,
                                    distanceCovered: distanceCovered,
                                    droneId: droneId,
                                    firmwareVersion: firmwareVersion,
                                    greenBuildNumber: greenBuildNumber,
                                    droneName: droneName,
                                    droneUIN: droneUIN,
                                    software_edition: software_edition,
                                    plotArea: plotArea,
                                }
                            }}
                        ><img src={logAnalyzerIcon} title='Log Analyzer' className='flightDetailsIcon' /></Link>
                    </div>
                    <div className='flightDetailsConainerIcon'>
                        <img src={replayIcon} title='Replay' className='flightDetailsIcon' onClick={onReplayFlight} />
                    </div>
                    <div className='flightDetailsConainerIcon'>
                        <Link
                            to={{
                                pathname: '/aerogcsenterprise/remote_mission/detailedlog',
                                state: {
                                    user,
                                    flightId: flightID,
                                    request_id: requestId,
                                    planName: planName,
                                    projectName: projectName,
                                    date: date,
                                    startTime: startTime,
                                    endTime: endTime,
                                    avgAltitude: avgAltitude,
                                    avgSpeed: avgSpeed,
                                    onViewDetaiils: onViewDetaiils,
                                    areaCovered: areaCovered,
                                    areaCoveredMethod: areaCoveredMethod,
                                    distanceCovered: distanceCovered,
                                    droneId: droneId,
                                    firmwareVersion: firmwareVersion,
                                    greenBuildNumber: greenBuildNumber,
                                    droneName: droneName,
                                    droneUIN: droneUIN,
                                    software_edition: software_edition,
                                    plotArea: plotArea,
                                }
                            }}
                        ><img src={detailsIcon} title='View Details' className='flightDetailsIcon' /></Link>
                    </div>
                    {/* <Button
                        className={'new-btn-lg'}
                        isBtnActive={true}
                        text={"View Details"}
                        linkData={{
                            pathname: '/aerogcsenterprise/remote_mission/detailedlog',
                            state: {
                                user,
                                flightId: flightID,
                                request_id: requestId,
                                planName: planName,
                                projectName: projectName,
                                date: date,
                                startTime: startTime,
                                endTime: endTime,
                                avgAltitude: avgAltitude,
                                avgSpeed: avgSpeed,
                                onViewDetaiils: onViewDetaiils,
                                areaCovered: areaCovered,
                                areaCoveredMethod: areaCoveredMethod,
                                distanceCovered: distanceCovered,
                                droneId: droneId,
                                firmwareVersion: firmwareVersion,
                                greenBuildNumber: greenBuildNumber,
                                droneName: droneName,
                                droneUIN: droneUIN,
                                software_edition: software_edition,
                                plotArea: plotArea,
                            }
                        }}
                    /> */}
                </div>
            </div>
            <div className="droneDetailsViewContainer" style={{ marginTop: '10px' }}>
                <div className="droneDetailsViewData" style={{ width: '50%', borderRadius: '0' }} >
                    <div className="droneDetailsViewSubTitle">Flight Details</div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Date">Date
                                {!date && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={date ? dateFormat(date, "dd mmm yyyy") : "NA"}>{date ? dateFormat(date, "dd mmm yyyy") : "NA"}</div>
                        </div>

                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Start Time">Start Time
                                {!startTime && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={startTime ? dateFormat(startTime, 'hh:MM:ss TT') : "NA"}>{startTime ? dateFormat(startTime, 'hh:MM:ss TT') : "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="End Time">End Time
                                {!endTime && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={endTime ? dateFormat(endTime, 'hh:MM:ss TT') : "NA"}>{endTime ? dateFormat(endTime, 'hh:MM:ss TT') : "NA"}</div>
                        </div>
                    </div>

                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Duration">Duration
                                {!(startTime && endTime) && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={(startTime && endTime) ? getFormatedDate(startTime, endTime) : "NA"}>{(startTime && endTime) ? getFormatedDate(startTime, endTime) : "NA"}</div>
                        </div>

                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Pilot Name">Pilot Name
                                {!(pilotName) && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={pilotName || "NA"}>{pilotName || "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }} />
                    </div>
                </div>

                <div className="droneDetailsViewData" style={{ width: '50%', borderRadius: '0' }}>
                    <div className="droneDetailsViewSubTitle">Spraying Details</div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title={software_edition === 'GREEN' || software_edition === 'GREEN Ag++' || software_edition === 'GREEN AG++' ? 'Sprayed Area'
                                : software_edition === 'ORANGE' ? 'Survey Area'
                                    : `${areaCoveredMethod && areaCoveredMethod != 'null' ? `Sprayed Area (by ${areaCoveredMethod})` : 'Area'}`}>
                                {software_edition === 'GREEN' || software_edition === 'GREEN Ag++' || software_edition === 'GREEN AG++' ? 'Sprayed Area'
                                    : software_edition === 'ORANGE' ? 'Survey Area'
                                        : `${areaCoveredMethod && areaCoveredMethod != 'null' ? `Sprayed Area (by ${areaCoveredMethod})` : 'Area'}`}
                                {!areaCovered && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}</div>
                            <div className="droneDetailsViewValues" title={areaCovered ? `${areaCovered} Acres` : "NA"}>{areaCovered ? `${areaCovered} Acres` : "NA"} </div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Plot Area">Plot Area
                                {!plotArea && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={plotArea ? `${plotArea} Acres` : 'NA'}>{plotArea ? `${plotArea} Acres` : 'NA'}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Consumed Liquid (ml)">Consumed Liquid (ml)
                                {!consumedLiquid && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={consumedLiquid ? consumedLiquid : "NA"}>{consumedLiquid ? consumedLiquid : "NA"}</div>
                        </div>
                    </div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Acres by Pilot">Acres by Pilot
                                {!acresByPilot && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={acresByPilot ? `${acresByPilot} Acres` : "NA"}>{acresByPilot ? `${acresByPilot} Acres` : "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Amount by Pilot">Amount by Pilot
                                {!totalCost && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={`₹ ${totalCost ? `${totalCost} ( ${acres} Acre  x  ₹${cost} )` : "0"}`}>{`₹ ${totalCost ? `${totalCost} ( ${acres} Acre  x  ₹${cost} )` : "0"}`}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Sprayed Distance (m)">Sprayed Distance (m)
                                {!distanceCovered && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={distanceCovered || "NA"}>{distanceCovered || "NA"}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="droneDetailsViewContainer" style={{ marginTop: '15px' }}>
                <div className="droneDetailsViewData" style={{ width: '50%', borderRadius: '0' }}>
                    <div className="droneDetailsViewSubTitle">Flight Parameters</div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Avg Altitude">Avg Altitude
                                {!avgAltitude && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={avgAltitude ? `${avgAltitude.toFixed(2)} m` : "NA"}>{avgAltitude ? `${avgAltitude.toFixed(2)} m` : "NA"}</div>
                        </div>

                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Avg Speed">Avg Speed
                                {!avgSpeed && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={avgSpeed ? `${avgSpeed.toFixed(2)} m/sec` : "NA"}>{avgSpeed ? `${avgSpeed.toFixed(2)} m/sec` : "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }} />
                    </div>
                    <div style={{ marginTop: '15px', }}>
                        {!droneName &&
                            <div className='grid_sub_title' style={{ fontSize: '14px', color: "black", display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                <div className='grid_sub_title' style={{ marginRight: "5px" }}> * </div>
                                <div>Note : {`${droneId} `}This drone is currently not registered</div>
                            </div>
                        }

                        {/* {(!firmwareVersion || !greenBuildNumber || !avgSpeed || !avgAltitude || !distanceCovered || !totalCost || !acresByPilot || !consumedLiquid || !plotArea || !areaCovered || !pilotName || !endTime || !startTime || !date)
                            && <div className='grid_sub_title' style={{ fontSize: '14px', color: "black", display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                <div className='grid_sub_title' style={{ marginRight: "5px" }}> * </div>
                                <div>NA : You may be using older version of {software_edition === 'GREEN' || software_edition === 'GREEN Ag++' || software_edition === 'GREEN AG++' || areaCoveredMethod && areaCoveredMethod != 'null' ? 'AeroGCS GREEN'
                                    : software_edition === 'ORANGE' ? 'AeroGCS ORANGE'
                                        : 'AeroGCS'}</div>
                            </div>} */}
                    </div>
                </div>

                <div className="droneDetailsViewData" style={{ width: '50%', borderRadius: '0' }}>
                    <div className="droneDetailsViewSubTitle">Drone Details</div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Drone Name">Drone Name
                                {!droneName && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={droneName ? droneName : "NA"}>{droneName ? droneName : "NA"} </div>
                        </div>
                        <div style={{ width: '66%' }}>
                            <div className="droneDetailsViewHeadings" title="Drone ID">Drone ID
                                {!droneId && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={droneId ? droneId : "NA"}>{droneId ? droneId : "NA"}</div>
                        </div>
                    </div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Drone UIN">Drone UIN
                                {!droneUIN && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={droneUIN ? droneUIN : "NA"}>{droneUIN ? droneUIN : "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Firmware Version">Firmware Version
                                {!firmwareVersion && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={firmwareVersion || "NA"}>{firmwareVersion || "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title={software_edition === 'GREEN' || software_edition === 'GREEN Ag++' || software_edition === 'GREEN AG++' || areaCoveredMethod && areaCoveredMethod != 'null' ? 'AeroGCS GREEN Build Number'
                                : software_edition === 'ORANGE' ? 'AeroGCS ORANGE Build Number'
                                    : 'AeroGCS Build Number'}>{software_edition === 'GREEN' || software_edition === 'GREEN Ag++' || software_edition === 'GREEN AG++' || areaCoveredMethod && areaCoveredMethod != 'null' ? 'AeroGCS GREEN Build Number'
                                        : software_edition === 'ORANGE' ? 'AeroGCS ORANGE Build Number'
                                            : 'AeroGCS Build Number'}
                                {!greenBuildNumber && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={greenBuildNumber || "NA"}>{greenBuildNumber || "NA"}</div>
                        </div>
                    </div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '66%' }}>
                            <div className="droneDetailsViewHeadings" title="GPS ID">GPS ID</div>
                            <div className="droneDetailsViewValues" title={gpsInfo ? JSON.parse(gpsInfo)?.gpsId : "NA"}>{gpsInfo ? JSON.parse(gpsInfo)?.gpsId : "NA"}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    </>


}

export default FlightDetailsBanner